import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { Clear as ClearIcon } from '@mui/icons-material'
import { useStyles } from './SlidesStyles'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CircularProgress from '@mui/material/CircularProgress'
export default function ReleaseConfirmation({ isReleaseConfirmationOpen, handleReleaseConfirmationClose }) {
  const classes = useStyles()
  const [isLoading, setLoading] = useState(true)
  const { workflowId } = useSelector((state: RootState) => state.getCaseData)
  const { re_saveReportData_success, re_saveReportData_error } = useSelector(
    (state: RootState) => state.saveReportDataResponse,
  )
  const { re_amendReport_success, re_amendReport_error } = useSelector((state: RootState) => state.saveAmendResponse)

  useEffect(() => {
    if (
      re_saveReportData_success &&
      (re_amendReport_success || re_amendReport_error) &&
      (workflowId === 'AMEND_INITIATED' || workflowId === 'AMEND_RESULTED_RESULT_RELEASED')
    ) {
      setTimeout(() => setLoading(false), 2000)
    } else if (re_saveReportData_success || re_saveReportData_error) {
      setTimeout(() => setLoading(false), 2000)
    }
  }, [re_amendReport_success, re_saveReportData_success])

  return (
    <>
      <Dialog fullWidth maxWidth="sm" open={isReleaseConfirmationOpen} onClose={handleReleaseConfirmationClose}>
        <DialogTitle className={classes.dialogTitle}>Confirmation</DialogTitle>
        <Divider />

        {isLoading &&
        ((!re_amendReport_success && !re_amendReport_error) ||
          (!re_saveReportData_success && !re_saveReportData_error)) ? (
          <DialogContent style={{ height: '130px' }}>
            <CircularProgress style={{ height: '40px', width: '40px', marginTop: '3%', marginLeft: '46%' }} />
          </DialogContent>
        ) : (
          <>
            <DialogContent style={{ height: '70px' }}>
              {re_saveReportData_success &&
                workflowId !== 'AMEND_INITIATED' &&
                workflowId !== 'AMEND_RESULTED_RESULT_RELEASED' && (
                  <>
                    <CheckCircleOutlineRoundedIcon style={{ color: 'green', width: '50px', verticalAlign: 'middle' }} />
                    <label>The report has been successfully saved for release.</label>
                  </>
                )}
              {re_saveReportData_error &&
                workflowId !== 'AMEND_INITIATED' &&
                workflowId !== 'AMEND_RESULTED_RESULT_RELEASED' && (
                  <>
                    <ErrorOutlineIcon style={{ color: 'red', width: '50px', verticalAlign: 'middle' }} />
                    Error occured while saving report, please try again.
                  </>
                )}
              {re_amendReport_success && (
                <>
                  <CheckCircleOutlineRoundedIcon style={{ color: 'green', width: '50px', verticalAlign: 'middle' }} />
                  <label>The amend report has been successfully saved for release.</label>
                </>
              )}
              {re_amendReport_error && !re_amendReport_success && (
                <>
                  <ErrorOutlineIcon style={{ color: 'red', width: '50px', verticalAlign: 'middle' }} />
                  Error occured while performing the amend report, please try again.
                </>
              )}
            </DialogContent>
            <DialogActions className={classes.buttonActions}>
              <Button
                className={`${classes.buttonMargin}`}
                variant="outlined"
                endIcon={<ClearIcon />}
                onClick={handleReleaseConfirmationClose}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  )
}
